import { render, staticRenderFns } from "./comment-creer-un-compte-instagram.vue?vue&type=template&id=acd0876c&"
import script from "./comment-creer-un-compte-instagram.vue?vue&type=script&lang=js&"
export * from "./comment-creer-un-compte-instagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports